import { normaliser } from './recherche'

/** Unités proposées à la saisie (une autre unité reste possible). */
export const UNITES = ['u', 'm', 'm²', 'm³', 'ml', 'kg', 'h', 'forfait']

// Variantes courantes des fichiers d'artisans et de fournisseurs
const VARIANTES: Record<string, string> = {
  u: 'u', un: 'u', unite: 'u', unites: 'u', pce: 'u', pc: 'u', piece: 'u', pieces: 'u', p: 'u',
  m: 'm', metre: 'm', metres: 'm',
  m2: 'm²', 'm²': 'm²', metre2: 'm²', 'metre carre': 'm²', 'metres carres': 'm²',
  m3: 'm³', 'm³': 'm³', metre3: 'm³', 'metre cube': 'm³', 'metres cubes': 'm³',
  ml: 'ml', 'metre lineaire': 'ml', 'metres lineaires': 'ml',
  kg: 'kg', kilo: 'kg', kilos: 'kg', kilogramme: 'kg', kilogrammes: 'kg',
  h: 'h', heure: 'h', heures: 'h', hr: 'h',
  forfait: 'forfait', ft: 'forfait', fft: 'forfait', f: 'forfait', ens: 'forfait', ensemble: 'forfait',
}

/** Unité reconnue ramenée à sa forme usuelle (« M2 » → « m² ») ; null si inconnue. */
export function normaliserUnite(saisie: string): string | null {
  const cle = normaliser(saisie).replace(/\.$/, '').replace(/\s+/g, ' ').trim()
  return VARIANTES[cle] ?? null
}
